import { Container } from '@/components/Container';
import { IContainerProps } from '@/types/IContainerProps';

export const RoundBorderContainer = ({ children, overflowYScroll, sx = {}, ...rest }: IContainerProps) => {
  return (
    <Container className={'round-border-container'} {...rest} sx={{ ...sx, width: '100%' }}>
      <Container
        sx={{
          ...sx,
          width: '100%',
          borderRadius: '10px',
          borderStyle: 'solid',
          borderColor: '#c3c3c3',
          overflow: overflowYScroll ? 'scroll' : 'hidden',
        }}
      >
        {children}
      </Container>
    </Container>
  );
};
